export default __webpack_public_path__ + "static/media/current_location.902281db.svg";